import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@getro/rombo';
import { ChevronDown, Mail } from 'lucide-react';
import { Dropdown } from '../../../../molecules/dropdown';

const Menu = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 240px;
  padding: 4px 0;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  box-shadow: ${({ theme }) => theme.shadows.medium};
`;

// `sx`, not styled(Button): styled-components would consume the `as` prop the
// mailto variant needs and drop the button styling with it.
const clampToColumn = { maxWidth: '100%', svg: { flex: '0 0 auto' } };

const Label = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const MenuItem = styled.a`
  display: block;
  padding: 8px 16px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.dark};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.neutral[20]};
  }
`;

export const EmailButton = ({ emails, firstName, onSelect }) => {
  if (!emails || emails.length === 0) return null;

  const label = `Email ${firstName || 'contact'}`;

  if (emails.length === 1) {
    return (
      <Button
        as="a"
        sx={clampToColumn}
        href={`mailto:${emails[0]}`}
        variant="secondary"
        size="small"
        icon={Mail}
        onClick={() => onSelect?.(emails[0], 0)}
        data-action="email"
      >
        <Label title={label}>{label}</Label>
      </Button>
    );
  }

  return (
    <Dropdown
      placement="bottom-start"
      offset={4}
      trigger={
        <Button variant="secondary" size="small" type="button" icon={Mail} data-action="email" sx={clampToColumn}>
          <Label title={label}>{label}</Label>
          <ChevronDown size={14} strokeWidth={2} aria-hidden="true" />
        </Button>
      }
    >
      <Menu role="menu">
        {emails.map((email, idx) => (
          <MenuItem key={email} href={`mailto:${email}`} role="menuitem" onClick={() => onSelect?.(email, idx)}>
            {email}
          </MenuItem>
        ))}
      </Menu>
    </Dropdown>
  );
};

EmailButton.propTypes = {
  emails: PropTypes.arrayOf(PropTypes.string),
  firstName: PropTypes.string,
  onSelect: PropTypes.func,
};

EmailButton.defaultProps = {
  emails: [],
  firstName: undefined,
  onSelect: undefined,
};
